import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

import Hero from './pages/Hero';
import About from './pages/About';
import Services from './pages/Services';
import Portfolio from './pages/Portfolio';
import Contact from './pages/Contact';

function ScrollObserver(){
  const location = useLocation();
  useEffect(()=>{
    // scroll to top on navigation
    window.scrollTo(0,0);

    // re-run intersection observer so newly mounted elements get observed
    const observer = new IntersectionObserver((entries)=>{
      entries.forEach(e=>{ if(e.isIntersecting){ e.target.classList.add('visible'); observer.unobserve(e.target) }})
    },{threshold:.1});
    document.querySelectorAll('.scroll-reveal').forEach(el=>observer.observe(el));

    return ()=>{
      observer.disconnect();
    };
  },[location]);

  return null;
}

export default function App(){
  const [showBackToTop, setShowBackToTop] = useState(false);

  useEffect(()=>{
    const observer = new IntersectionObserver((entries)=>{
      entries.forEach(e=>{ if(e.isIntersecting){ e.target.classList.add('visible'); observer.unobserve(e.target) }})
    },{threshold:.1});
    document.querySelectorAll('.scroll-reveal').forEach(el=>observer.observe(el));

    // Back to top button visibility
    function onScroll(){ setShowBackToTop(window.scrollY > 400); }
    window.addEventListener('scroll', onScroll);
    return ()=>window.removeEventListener('scroll', onScroll);
  },[]);

  function scrollToTop(){ window.scrollTo({top:0, behavior:'smooth'}); }

  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <div>
        {/* Site-wide minimal background (CSS-only, no deps) */}
        <div className="site-bg" aria-hidden="true">
          <svg className="site-lines" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
            <path d="M -80 220 Q 120 120, 320 70" className="site-arc" />
            <path d="M 720 -60 Q 880 120, 1080 320" className="site-arc" />
            <path d="M 380 320 Q 600 280, 820 320" className="site-arc center" />
          </svg>
          <div className="site-blob site-blob-1" />
          <div className="site-blob site-blob-2" />
          <div className="site-geom site-geom-1" />
          <div className="site-geom site-geom-2" />
          <div className="site-ring site-ring-1" />
          <div className="site-dots">
            {Array.from({length: 10}).map((_, i) => (
              <span key={i} className={`site-dot site-dot-${i+1}`} />
            ))}
          </div>
        </div>
        <Navbar />
        {/* Re-run intersection observer and reset scroll on navigation */}
        <ScrollObserver />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Hero/>} />
            <Route path="/about" element={<About/>} />
            <Route path="/services" element={<Services/>} />
            <Route path="/portfolio" element={<Portfolio/>} />
            <Route path="/contact" element={<Contact/>} />
          </Routes>
        </main>
        <Footer compact />
        {/* Back to Top Button */}
        <button 
          aria-label="Back to top" 
          className={`back-to-top ${showBackToTop? 'show':''}`} 
          onClick={scrollToTop}
        >
          ↑
        </button>
      </div>
    </BrowserRouter>
  );
}
